"use client"

import type { ReactNode } from "react"

import set from "lodash/set"
import { useFormContext, useWatch } from "react-hook-form"
import { ZodEffects, ZodObject } from "zod"

import { useValidationContext } from "#components/form/rhfFormContext"
import { innerType } from "#utils/zodUtils"

/**
 * Shows the children conditionally, only when the field watchName has a valid input based on the passed zod schema
 */
export function DynamicField({ watchName, children }: { watchName: string; children: ReactNode }) {
  const { control } = useFormContext()
  const { validationSchema } = useValidationContext()

  const watchedValue = useWatch({ control, name: watchName })

  if (!validationSchema || !(validationSchema instanceof ZodObject || validationSchema instanceof ZodEffects)) {
    return <>{children}</>
  }

  const pickPath = set({}, watchName, true)
  const validationResult = innerType(validationSchema)
    .pick(pickPath)
    .safeParse({ [watchName]: watchedValue })

  return <>{validationResult.success && children}</>
}
